import React, { ReactNode } from 'react';
import { MinimumPricingBreakdown } from '@interfaces/pricingBreakdown';
import BuyerFees from '@components/buyer-fees/buyer-fees-content/buyer-fees';
import Tooltip from '@components/atoms/tooltip/tooltip';
import { OfferDetails } from '@interfaces/models/negotiation/negotiationEvent';

export interface PriceBreakdownTooltipProps {
  children?: ReactNode;
  breakdown?: MinimumPricingBreakdown;
  offerDetails?: OfferDetails;
  direction?: 'top' | 'bottom' | 'left' | 'right';
  isSeller: boolean;
  productLocation?: string;
  buyerLocation?: string;
}

const PriceBreakDownTooltip: React.FC<PriceBreakdownTooltipProps> = ({
  children,
  isSeller,
  breakdown,
  offerDetails,
  direction = 'bottom',
  buyerLocation,
  productLocation,
}) => {
  if (!breakdown && !offerDetails) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      delay={0}
      direction={direction}
      clickMode={true}
      textTrigger={true}
      tooltipContent={
        breakdown ? (
          <BuyerFees
            style={{ maxWidth: '300px' }}
            breakdown={breakdown}
            isSeller={isSeller}
            productLocation={productLocation}
            buyerLocation={buyerLocation}
            compactMod={true}
          />
        ) : (
          <BuyerFees
            style={{ maxWidth: '300px' }}
            offerDetails={offerDetails}
            isSeller={isSeller}
            productLocation={productLocation}
            buyerLocation={buyerLocation}
            compactMod={true}
          />
        )
      }
    >
      {children}
    </Tooltip>
  );
};

export default PriceBreakDownTooltip;
